// @ai-generated 2026-09-17T10:27:43+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useAgenticOrchestratorRepository } from '@Hooks/useRepository';
import { ChatThreadsRepository } from '@Repositories/AgenticOrchestrator';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

const THREADS_KEY = ['agentic-orchestrator', 'chat_threads'];
const PAGE_SIZE = 50;

/** The signed-in user's own conversations, most recently used first. */
export function useChatThreads() {
    const chatThreads = useAgenticOrchestratorRepository(ChatThreadsRepository);

    const { data, isLoading, error } = useQuery({
        queryKey: THREADS_KEY,
        queryFn: () => chatThreads.getListGet(0, PAGE_SIZE, ''),
    });

    return { threads: data?.data?.items ?? [], isLoading, error };
}

/** Deletes a conversation and refreshes the list. */
export function useDeleteChatThread() {
    const chatThreads = useAgenticOrchestratorRepository(ChatThreadsRepository);
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation({
        mutationFn: (threadId: string) => chatThreads.delete(threadId),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: THREADS_KEY }),
    });

    return { deleteThread: mutateAsync, isDeleting: isPending };
}

/** Drops the cached list so a newly started conversation shows up in the rail. */
export function useRefreshChatThreads() {
    const queryClient = useQueryClient();
    return useCallback(() => queryClient.invalidateQueries({ queryKey: THREADS_KEY, exact: true }), [queryClient]);
}
